import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {FormsModule} from '@angular/forms';
import {ToastModule} from 'primeng/toast';
import {RouterModule} from '@angular/router';
import {AccountResetPasswordComponent} from './account-reset-password/account-reset-password.component';
import {AccountResetEmailComponent} from './account-reset-email/account-reset-email.component';
import {AuthGuard} from '../admin/auth/auth.guard';

const routes = [
    {
        path: '',
        component: LoginComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'account/reset/finish',
        component: AccountResetPasswordComponent
    },
    {
        path: 'account/reset/init',
        component: AccountResetEmailComponent
    }
]

@NgModule({
    declarations: [LoginComponent, AccountResetPasswordComponent, AccountResetEmailComponent],
    imports: [CommonModule, FormsModule, ToastModule, RouterModule.forChild(routes)],
    exports: [LoginComponent, AccountResetPasswordComponent],
})
export class DmpLoginModule {}
